'use strict';

import React from 'react'

import _ from 'lodash'

import { search } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'

import Layout from '@Layout/BackOffice'

import ProductInfos from '@/ProductInfos'

import FormElement from '@/Form/toolkit/FormElement'

import Loader    from '@Pure/Loader'
import SearchBar from '@Pure/SearchBar'

export default class ProductsManagementPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			tickets: [],
			actions: [],
			searched:
			{
				value: ''
			},
			filter_status: [],
			form_data: { },
			status_messages: { }
		};

		this.handleFilterChange   = this.handleFilterChange.bind(this);
		this.handleTrackingChange = this.handleTrackingChange.bind(this);
		this.handleNumChange      = this.handleNumChange.bind(this);
		this.handleSearch         = this.handleSearch.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'changedTicketTracking',
			cb: component.handleTrackingChange
		});

		app.push(
		{
			event: 'changedTicketNum',
			cb: component.handleNumChange
		});

		let filter_query =
		{
			sort: 'createdAt DESC'
		};

	// get all orders
		qwest.post('/CMS/getAll',
		{
			model: 'order',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			let tickets = [];

			response.data.forEach(function (order)
			{
				order.products
				.forEach(function (product, key)
				{
					Object.keys(product.tickets).forEach(function (ticket_id)
					{
						tickets.push(
						{
							product: product,
							order: order,
							ticket_id: ticket_id
						});
					});
				});
			});

			component.setState({ tickets: tickets });
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'changedTicketTracking',
			cb: component.handleTrackingChange
		});

		app.delete(
		{
			event: 'changedTicketNum',
			cb: component.handleNumChange
		});
	}

	handleFilterChange (e, data)
	{
		const component = this, props = this.props;

		handleChange.bind(component)(e, data);

		if (!e) return;

		let value = e.target.checked;
		let name  = e.target.name.split('status[').join('').split(']').join('');

		if (value)
		{
			component.state.filter_status.push(name);
		}
		else
		{
			component.state.filter_status = component.state.filter_status
				.filter(status => status !== name);
		}

		component.setState(
		{
			filter_status: component.state.filter_status
		});
	}

	handleTrackingChange (data)
	{
		const component = this, props = this.props;

		let ticket = component.state.tickets
			.find(ticket => ticket.ticket_id === data.ticket.ticket_id);

		ticket.product.tickets[ticket.ticket_id].tracking = data.tracking;
		ticket.product.tickets[ticket.ticket_id].status   = 'completed';

		component.setState(
		{
			tickets: component.state.tickets
		});
	}

	handleNumChange (data)
	{
		const component = this, props = this.props;

		let ticket = component.state.tickets
			.find(ticket => ticket.ticket_id === data.ticket.ticket_id);

		ticket.product.tickets[ticket.ticket_id].num = data.num;
		ticket.product.tickets[ticket.ticket_id].status   = 'completed';

		component.setState(
		{
			tickets: component.state.tickets
		});
	}

	handleSearch (value, search)
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	openTrackingModal (e, ticket)
	{
		app.emit('open__TicketTrackingModal', ticket);
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const searched      = component.state.searched.value;
		const filter_status = component.state.filter_status;

		let tickets = component.state.tickets
		.filter(function (ticket)
		{
			if (searched.length <= 1 && filter_status.length === 0)
			{
				return true;
			}

			let ticket_infos = ticket.product.tickets[ticket.ticket_id] || { };

			let matches = 0;

			if (filter_status.length > 0)
			{
				if (filter_status.includes(ticket_infos.status) === false)
				{
					return false;
				}
			}

			matches += search(ticket.order.number, searched);
			matches += search(ticket.product.price.ref, searched);
			matches += search(ticket.order.user.firstname + ' ' +
				ticket.order.user.lastname, searched);

			return matches > 0;
		})
		.map(function (ticket)
		{
			let ticket_infos = ticket.product.tickets[ticket.ticket_id] || { };

			let actions = {};

			let edit_icon =
			(
				<svg className="o-svg-icon o-svg-icon--edit c-order-infos__add-icon">
					<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
				</svg>
			);

			if (ticket.order.shipping.method === 'home')
			{
				let class_name = 'c-order-infos__add-btn';

				if (ticket_infos.tracking)
				{
					class_name += ' edit';
				}

				actions.tracking =
				(
					<button className={ class_name } onClick={ function (e)
					{
						component.openTrackingModal(e, ticket);
					}}>
						{ ticket_infos.tracking ? edit_icon : undefined }
					</button>
				);
			}

			{
				let class_name = 'c-order-infos__add-btn';

				if (ticket_infos.num)
				{
					class_name += ' edit';
				}

				actions.num =
				(
					<button className={ class_name } onClick={ function (e)
					{
						e.preventDefault();
					}}>
						{ ticket_infos.num ? edit_icon : undefined }
					</button>
				);
			}

			let output =
			(
				<ProductInfos key={ ticket.ticket_id } ticket={ ticket } admin={ true }
					open_by_default={ true } actions={ actions } />
			);

			return output;
		});

		let header =
		(
			<div className="c-order-infos--header">

				<div className="c-order-infos__order">

					<div className="c-order-infos__ref">Ref produit</div>

					<div className="c-order-infos__ticket-date">Date de cde</div>

					<div className="c-order-infos__name">Informations</div>

					<div className="c-order-infos__ticket-num">N° de billet</div>

					<div className="c-order-infos__tracking">N° Suivi</div>

					<div className="c-order-infos__product-status">État</div>

				</div>

			</div>
		);

		var output =
		(
			<Layout history={ props.history } page_title="Gestion des commandes">

				<div className="page-content">

					<div className="o-grid-2 u-margin-bottom-20 order-management-filters">

						<div className="o-grid__item">
							<SearchBar hide_btn={ true } placeholder="Recherche..."
								handleChange={ component.handleSearch }
								value={ state.searched.value } />
						</div>

						<div className="o-grid__item">

							<FormElement name="status[new]"
								type="checkbox" data={ state.form_data }
								onChange={ component.handleFilterChange }
								status={ state.status_messages } label="Acheté" />

							<FormElement name="status[completed]"
								type="checkbox" data={ state.form_data }
								onChange={ component.handleFilterChange }
								status={ state.status_messages } label="Terminé" />

							<FormElement name="status[canceled]"
								type="checkbox" data={ state.form_data }
								onChange={ component.handleFilterChange }
								status={ state.status_messages } label="Annulé" />

						</div>

					</div>

					{ header }

					{ tickets }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}